
import PlacesVisual1 from "../../img/screenshots/places/places-feature-01.png";
import PlacesVisual2 from "../../img/screenshots/places/places-feature-02.png";
import PlacesVisual3 from "../../img/screenshots/places/places-feature-03.png";
import PlacesVisual4 from "../../img/screenshots/places/places-feature-04.png";


export const PlacesFeaturesContent = [
    { 
      title:"Create maps of your favourite places",     
      subtitle:"Add any place in the world",      
      text:"Map out your favourite spots per destination or save the places you want to visit. Stippl can be where you build your bucket list.",
      image:PlacesVisual1
    },
    { 
      title:"Save the best places you’ve been to",     
      subtitle:"save your favourites",      
      text:"Go beyond the destinations and save your favourite activities, restaurants, bars and sightseeing locations.",
      image:PlacesVisual2
    },
    { 
      title:"Recommend (or not) the places you visited",     
      subtitle:"tag your saved places",      
      text:"Tag the places you saved according to whether you recommend them or not so others can have access to your feedback. ",
      image:PlacesVisual3
    },
    { 
      title:"Share the best spots with your friends",     
      subtitle:"Share your tips",      
      text:"Easily share a link with your favourite spots on a certain location with your friends.",
      image:PlacesVisual4
    },
  ]